export const UNMODIFIABLE_DICOM_TAGS: string[] = [
  "Patient's Name",
  'Patient ID',
  "Patient's Birth Date",
  "Patient's Sex",
  'Study Instance UID',
  'Study Date',
  'Study Time',
  'Accession Number',
  'Study Description',
  "Referring Physician's Name",
  'Study ID',
  'Institution Name',
  'Station Name',
  'Manufacturer',
  "Manufacturer's Model Name",
]
